<template>
  <NeurologicalDiseaseView icd="G70.0"
                           icd-presentation-string="G70.0"
                           icd-description="Myasthenia gravis"
                           disease-description="Myasthenia gravis"
                           :project-description="projectDescription"
                           :mesh-ids="['D009157']"
                           mesh-description="Myasthenia Gravis">
  </NeurologicalDiseaseView>
</template>

<script>
import NeurologicalDiseaseView from '@/components/NeurologicalDiseaseView.vue';
import {defineComponent} from "vue";

export default defineComponent({
  name: 'myasthenia-gravis-page',
  components: {
    NeurologicalDiseaseView
  },
  data: () => ({
    projectDescription:
        '<h4>Background</h4>' +
        '<ul>' +
        '<li>Myasthenia gravis (MG) is a rare neurological disorder characterized by weakness in voluntary muscles.</li>' +
        '<li>There is no known cure for MG, and current treatment options focus on symptom alleviation.</li>' +
        '<li>Few studies have thoroughly characterized the medical burden of MG, and knowledge about routine care patterns remains scarce.</li>' +
        '</ul>' +
        '<h4>Aim</h4>' +
        '<ul>' +
        '<li>To visualize high-level real-world insights on MG in Sweden to stimulate internal discussions at Alexion and guide future research directions.</li>' +
        '</ul>' +
        '<h4>Methods</h4>' +
        '<ul>' +
        '<li>This study used data from a Statistical Order (aggregated statistical tables) to explore epidemiology and demography, treatment patterns, and outcomes of patients diagnosed with MG (ICD-10-SE: G70.0) between 2000 and 2024 in Sweden.</li>' +
        '<li>The Statistical Order contained data from the National Patient Register, Prescribed Drug Register, and Cause of Death Register.</li>' +
        '</ul>' +
        '<h4>Results</h4>' +
        '<ul>' +
        '<li>Between 2000 and 2024, 6290 patients were diagnosed with MG in Sweden. The majority of patients (74%) were diagnosed at the age of 50 years or above.</li>' +
        '<li>The annual incidence rate of MG in Sweden has remained stable between 2.0 and 2.6 cases per 100,000 between 2003 and 2024.</li>' +
        '<li>Among patients included in this study, around 74% received acetylcholinesterase inhibitors, 61% received corticosteroids, and 3% underwent plasma exchange.</li>' +
        '<li>Around 37% of the total cohort died during the follow-up, of which 96% occurred in patients diagnosed at the age of 50 years or above.</li>' +
        '</ul>' +
        '<h4>Conclusions</h4>' +
        '<ul>' +
        '<li>The results were consistent with previous literature and further highlights the substantial clinical burden among patients with MG in Sweden.</li>' +
        '</ul>'
  })
});
</script>
